export default __webpack_public_path__ + "static/media/parents.6f98210c.png";